/** Footer-only fallback URLs when API config is unavailable. Download gateway uses DB config. */
export const ZANGIA_APP_STORE_URL =
  'https://apps.apple.com/us/app/zangia-mn/id1529088448';
export const ZANGIA_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=mzm.biznetwork.app&hl=mn';

export const APP_STORE_BADGE = '/images/footer/app-store.png';
export const PLAY_STORE_BADGE = '/images/footer/google-play.png';
